import constant from '../../constant'

const initialState = { 
  content: {
    creator: {
      profilePic: ''
    }
  },
  recommends: [],
  banner: []
};

export function shortContents (state = initialState, action) {

  switch (action.type) {
    case constant.SHORT_CONTENT.CONTENT:
      return {
        ...state,
        ...action.shortContents
      }
    default:
      return state
  }

}